import { Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

export interface IMagicLinkSuccess {
  resendLink: (e: any) => Promise<void>;
}

export const MagicLinkSuccess = ({ resendLink }: IMagicLinkSuccess) => {
  return (
    <section>
      <Typography variant="h2" className={prefixClassName("magic-link-header")}>
        📧 <br />
        {typedLocalize("passwordlessLogin.magicLinkSuccessHeader")}
      </Typography>
      <main>
        <Stack gap="30px" sx={{ alignItems: "center" }}>
          <span>{typedLocalize("passwordlessLogin.magicLinkSuccessBody")}</span>
        </Stack>
      </main>
      <footer style={{ marginTop: "20px" }}>
        <Typography variant="caption2" sx={{ textDecoration: "underline", cursor: "pointer" }}>
          <span onClick={resendLink}>{typedLocalize("passwordlessLogin.magicLinkSuccessResendLinkBtn")}</span>
        </Typography>
      </footer>
    </section>
  );
};
